import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ status: "loading", email: null });

  useEffect(() => {
    if (!token) { setState({ status: "error", email: null }); return; }
    api.get(`/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => setState({ status: "done", email: r.data?.email || null }))
      .catch(() => setState({ status: "error", email: null }));
  }, [token]);

  return (
    <div data-testid="unsubscribe-page" className="bg-white min-h-screen flex flex-col text-ink">
      <Header />
      <main className="flex-1 grid place-items-center px-6 pt-32 pb-20">
        <div className="max-w-xl w-full text-center">
          {state.status === "loading" && (
            <>
              <Loader2 className="animate-spin text-brand mx-auto" size={32} />
              <p className="mt-4 text-ink/70">Updating your preferences...</p>
            </>
          )}
          {state.status === "done" && (
            <>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-soft border border-brand/20 mb-8">
                <CheckCircle2 className="text-brand" size={28} />
              </div>
              <h1 className="font-display text-3xl sm:text-4xl tracking-[-0.025em] text-ink">You&apos;re unsubscribed.</h1>
              <p className="mt-4 text-ink/65">{state.email ? `We've removed ${state.email} from all marketing emails. ` : ""}You will no longer receive nurture or follow-up messages.</p>
              <div className="mt-8">
                <Link to="/"><Button variant="outline" className="btn-outline-ink rounded-full h-11 px-6">Back to Home</Button></Link>
              </div>
            </>
          )}
          {state.status === "error" && (
            <>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 border border-red-200 mb-8">
                <XCircle className="text-red-500" size={28} />
              </div>
              <h1 className="font-display text-3xl sm:text-4xl tracking-[-0.025em] text-ink">Invalid link</h1>
              <p className="mt-4 text-ink/65">This unsubscribe link is invalid or expired. Email us at info@itsthefreedominme.com and we&apos;ll remove you manually.</p>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
